export const Loading = styled.div`
    width: 100%;
    bottom: 50%;
    position: fixed;
    z-index: 1;

    .ms-Spinner-circle {
        height: 40px;
        width: 40px;
        margin-top: 25px;
    }

    .ms-Spinner .ms-Spinner-label {
        color: #2b579a;
        font-size: 30px;
    }
`;
